/*
 *  Collection Template
 *    Contains all the scripts used for the collection template.
 *
 *  Version:
 *    1.0.0 - 2023/06/05
 */
import { Section } from '../tools/section';

// Selectors
const SELECTOR_CONTAINER = "[data-blog-listing]";
const SELECTOR_FEATURED_ARTICLE = '[data-featured-articles]';

class BlogListing extends Section {
  
  queryChildren(container: HTMLElement): void {
    this.removeFeaturedArticle();
    this.scrollToListing();
  }

  attachEvents() {}

  detatchEvents(): void {}

  private scrollToListing() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('page')) return;

    const header = document.querySelector<HTMLElement>('[data-sticky-header]');
    const yOffset = -(header?.offsetHeight ?? 80);

    const targetEl = this.container;
    if (!targetEl) return;

    const tryScroll = (retries = 5) => {
      // @ts-ignore
      const lenis = (window as any).lenis;
      if (lenis && typeof lenis.scrollTo === 'function') {
        lenis.scrollTo(targetEl, {
          offset: yOffset,
          duration: 1,
          immediate: false,
        });
      } else if (retries > 0) {
        // retry on next frame until Lenis is ready
        requestAnimationFrame(() => tryScroll(retries - 1));
      } else {
        // fallback to native scroll
        const y = targetEl.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    };

    // Double rAF to ensure layout is ready, then attempt scrolling
    requestAnimationFrame(() => requestAnimationFrame(() => tryScroll()));
  }

  private removeFeaturedArticle() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('page')) return;

    document.querySelector(SELECTOR_FEATURED_ARTICLE)?.remove();
  }
}

Section.register(SELECTOR_CONTAINER, BlogListing);